import "./Products.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import EssentialFamilyBundles from "./sections/EssentialFamilyBundles";
import B2BComplianceStandards from "./sections/B2BComplianceStandards";
import EngineeringFooter from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <PrimaryNavigation />
      <EssentialFamilyBundles />
      <B2BComplianceStandards />
      <EngineeringFooter />
    </div>;
}